// extracted by mini-css-extract-plugin
export var legendIndicator = "_bh-1";
export var legendRight = "_bh-0";